<template>
  <div v-if="Object.values(impressao).length > 0"
       @keyup="changeImpressao">
    <div class="row mt-3">
      <div class="col text-center">
        <label for="input_nome"
               class="impressao--label">Nome</label>
        <input id="input_nome"
               v-model="impressao.pessoa.nome"
               class="form-control form-control-sm text-center"
               type="text">
      </div>
    </div>

    <div class="row mt-3">
      <div
        class="col-4 offset-4 text-center">
        <label for="input_nome"
               class="impressao--label">Número do CPF</label>
        <input id="input_nome"
               v-model="impressao.pessoa.cpf"
               v-mask="`999.999.999-99`"
               placeholder="NÃO CONSTA"
               class="form-control form-control-sm text-center"
               type="text">
      </div>
    </div>

    <div v-if="impressao.registro"
         class="row mt-">
      <div class="col-6 offset-3 text-center">
        <label for="input_nome"
               class="impressao--label">Matricula</label>
        <input id="input_nome"
               v-model="impressao.registro.matricula"
               v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
               class="form-control form-control-sm text-center"
               disabled
               type="text">
      </div>
    </div>

    <div v-if="impressao.registro && impressao.registro.data_ocorrido">
      <div class="row mt-3">
        <div class="col-8">
          <label for="input_nome"
                 class="impressao--label">Data de nascimento</label>
          <input id="input_nome"
                 v-model="impressao.registro.data_ocorrido.extenso"
                 class="form-control form-control-sm"
                 type="text">
        </div>
        <div class="col row">
          <div class="col">
            <label for="input_nome"
                   class="impressao--label">Dia</label>
            <input id="input_nome"
                   v-model="impressao.registro.data_ocorrido.dia"
                   :disabled="data_desconhecida.status"
                   class="form-control form-control-sm"
                   type="number"
                   min="0"
                   placeholder="N/C">
          </div>
          <div class="col">
            <label for="input_nome"
                   class="impressao--label">Mês</label>
            <input id="input_nome"
                   v-model="impressao.registro.data_ocorrido.mes"
                   :disabled="data_desconhecida.status"
                   class="form-control form-control-sm"
                   type="number"
                   min="0"
                   placeholder="N/C">
          </div>
          <div class="col">
            <label for="input_nome"
                   class="impressao--label">Ano</label>
            <input id="input_nome"
                   v-model="impressao.registro.data_ocorrido.ano"
                   :disabled="data_desconhecida.status"
                   class="form-control form-control-sm"
                   type="number"
                   min="0"
                   placeholder="N/C">
          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col">
          <!--TODO: IMPLEMENTAR DATA DESCONHECIDA-->
          <b-form-checkbox id="data_falecimento_descinhecida"
                           v-model="data_desconhecida.status"
                           switch
                           @change="dataDesconhecida()">
            Data desconhecida
          </b-form-checkbox>
        </div>
      </div>
    </div>

    <div v-if="impressao.registro"
         class="row mt-3">
      <div class="col-5">
        <label for="hora_nascimento"
               class="impressao--label">Horário de nascimento</label>
        <input v-model="horaFormatada"
               type="time"
               class="form-control form-control-sm">
      </div>

      <div class="col">
        <label for="naturalidade"
               class="impressao--label">Município da naturalidade</label>
        <input v-model="impressao.pessoa.naturalidade"
               type="text"
               placeholder="NÃO CONSTA"
               class="form-control form-control-sm">
      </div>
      <div class="col-1">
        <label for="naturalidade"
               class="impressao--label">UF</label>
        <input v-model="impressao.pessoa.uf"
               type="text"
               placeholder="N/C"
               class="form-control form-control-sm">
      </div>
    </div>

    <div v-if="impressao.registro"
         class="row mt-3">
      <div class="col">
        <label for="naturalidade"
               class="impressao--label">Local de nascimento</label>
        <input v-model="impressao.registro.local_nascimento" 
               type="text"
               placeholder="NÃO CONSTA"
               class="form-control form-control-sm">
      </div>

      <div class="col">
        <label for="naturalidade"
               class="impressao--label">Município de nascimento</label>
        <input v-model="impressao.registro.local.endereco.cidade"
               type="text"
               placeholder="NÃO CONSTA"
               class="form-control form-control-sm">
      </div>

      <div class="col-1">
        <label for="uf-nascimento"
               class="impressao--label">UF</label>
        <input v-model="impressao.registro.local.endereco.uf"
               type="text"
               placeholder="N/C"
               class="form-control form-control-sm">
      </div>

      <div class="col-2">
        <label for="naturalidade"
               class="impressao--label">Sexo</label>
        <select id="sexoNascido"
                v-model="impressao.pessoa.sexo"
                class="custom-select custom-select-sm"
                name="sexoNascido"
                @change="changeData()">
          <option selected
                  value="">
            Selecione
          </option>
          <option v-for="sexo in SEXOS"
                  :key="sexo.name"
                  :value="sexo.name">
            {{ sexo.name }}
          </option>
        </select>
      </div>
    </div>

    <div>
      <SubHeaderGrey class="row mt-3 mb-1">
        <div class="d-flex justify-content-between pb-1 pl-2">
          Genitores
        </div>
      </SubHeaderGrey>
      <div v-if="impressao.pessoa.genitores.length"
           class="w-100">
        <div v-for="(genitor, index) in impressao.pessoa.genitores" 
             :key="index" 
             class="card mt-3 w-100">
          <GenitorCard :genitor="genitor" 
                       :genitor-index="index"
                       @updateGenitor="handleOpenUpdadeGenitor"
                       @deleteGenitor="handleDeleteGenitor" />
        </div>
      </div>    
      <AddGenitorModal :show="showGenitorModal"
                       :genitor-selecionado="genitorSelecionado"
                       :index-genitor-seleciodado="indexGenitorSeleciodado"
                       @close="handleCloseAddGenitor"
                       @updateGenitor="handleUpdateGenitor"
                       @createGenitor="handlecreateGenitor" />
      <button variant="primary"
              class="btn btn-sm btn-add-genitor btn-outline-primary btn-add-anotacao btn-block my-3"
              :disabled="showGenitorModal"
              size="sm"
              @click="() => showGenitorModal = true">
        <IconSvg class="icon-add icon--sm mr-1"
                 icon="add" />
        Adicionar Genitor
      </button>
    </div>

    <div class="mt-3">
      <SubHeaderGrey class="row mt-3 mb-1">
        <div class="d-flex justify-content-between pb-1 pl-2">
          Gêmeos
        </div>
      </SubHeaderGrey>
  

      <div class="row">
        <div class="col-1">
          <span class="custom-control custom-radio custom-control-inline">
            <input id="gemeos_question_yes"
                   v-model="conditionals.gemeos"
                   type="radio"
                   name="gemeos"
                   :value="true"
                   class="custom-control-input">

            <label for="gemeos_question_yes"
                   class="custom-control-label">
              Sim
            </label>
          </span>
        </div>
        <div class="col-1">
          <span class="custom-control custom-radio custom-control-inline">
            <input id="gemeos_question_no"
                   v-model="conditionals.gemeos"
                   type="radio"
                   :value="false"
                   name="gemeos"
                   class="custom-control-input">

            <label for="gemeos_question_no"
                   class="custom-control-label">
              Não
            </label>
          </span>
        </div>
      </div>

      <div v-if="conditionals.gemeos"
           class="row mt-1">
        <div class="col-5">
          <label for="nome_matricula_gemeo"
                 class="impressao--label">Nome do gêmeo</label>
          <input id="nome_matricula_gemeo"
                 v-model="forms.gemeos.nome"
                 type="text"
                 class="form-control form-control-sm">
        </div>
        <div class="col-5">
          <label for="nome_matricula_gemeo"
                 class="impressao--label">Matrícula do gêmeo</label>
          <input id="nome_matricula_gemeo"
                 v-model="forms.gemeos.matricula"
                 type="text"
                 class="form-control form-control-sm">
        </div>
        <div class="col d-flex align-items-end">
          <button class="btn btn-sm btn-secondary btn-block"
                  :disabled="!(forms.gemeos.nome && forms.gemeos.matricula)"
                  @click="gemeos().adicionar()">
            Adicionar Gêmeo
          </button>
        </div>
      </div>

      <div v-if="conditionals.gemeos"
           class="row mt-2">
        <div class="col">
          <label>Gemeos:</label>
          <div v-for="gemeo in impressao.pessoa.gemeos"
               :key="`gemeos_${gemeo.matricula}`"
               class="col-12">
            <div class="col-6">
              {{ gemeo.nome }} - {{ gemeo.matricula }}
              <button class="btn btn-xs"
                      @click="gemeos().excluir(gemeo)">
                <icon-svg class="icon--sm icons--red"
                          icon="deleteIcon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3 d-flex">
      <div v-if="impressao.registro && impressao.registro.data_registro"
           class="col-8">
        <label for="input_nome"
               class="impressao--label">Data de registro</label>
        <input id="input_nome"
               v-model="impressao.registro.data_registro.extenso"
               class="form-control form-control-sm"
               type="text">
      </div>
      <div class="col-4">
        <label for="numero_dnv"
               class="impressao--label">
          DNV
        </label>
        <input id="numero_dnv"
               v-model="impressao.dnv"
               v-mask="'##-########-#'"
               placeholder="NÃO CONSTA"
               type="text"
               class="form-control form-control-sm">
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <label for="averbacoes"
               class="impressao--label">
          Anotações / Averbações
        </label>
        <div id="nascimento_pessoa_averbacoes"
             class="editorHtml"
             contenteditable="true"
             @blur="getHtml('averbacoes')"
             v-html="impressao.averbacao_certidao" />
      </div>
    </div>
  </div>


  <!-- fim formulario -->
</template>

<script>
  /* helpers */
  import DataExtensoHelper from "@/helpers/Datas/DataExtensoHelper"

  /* filters */
  import { filterDate } from "@/filters/filters"
  import { endereco } from "@/filters/endereco"

  /* libraries */
  import { mapGetters } from "vuex"
  import AddGenitorModal from "./AddGenitorModal"
  import GenitorCard from "./GenitorCard"
  import SubHeaderGrey from "@/components/SofiaRei/Headers/SubHeaderGrey"
  import brazilianStates from '@/constants/brazilianStates'

  import SEXOS from "@/constants/sexos"

  export default {
    name: "ImpressaoFormularioNascimento",
    components: {
      AddGenitorModal,
      GenitorCard,
      SubHeaderGrey
    },
    props: {
      data: { type: Object, default: () => ({})},
      cartorioObj: { type: Object, default: () => ({})},
      propOrgaoEmissor: { type: Object, default: () => ({})},
      propAverbacoes: { type: Array, default: () => ([])}
    },
    data () {
      return {
        data_desconhecida: {
          bkp: {},
          status: false
        },
        impressao: {
          registro: {
            data_registro: {},
            data_ocorrido: {},
            local: {
              hospital: {
                nome: 'NÃO CONSTA'
              },
              endereco: {
                cidade: 'NÃO CONSTA',
                uf: ''
              }
            }
          },
          pessoa: {
            uf: '',
            municipio: 'SEM INFORMAÇÃO',
            gemeos: []
          },
          dados: {}
        },
        conditionals: {
          gemeos: false
        },
        forms: {
          gemeos: {
            nome: null,
            matricula: null,
          }
        },
        sexos: {
          I: 'Ignorado',
          F: 'Feminino',
          M: 'Masculino'
        },
        genitorSelecionado: null,
        showGenitorModal: false,
        ufOptions: brazilianStates.map((item) => ({value: item.uf, text: item.uf})),
        SEXOS
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        // cartorioObj: 'auth/getCartorioObj'
      }),

      horaFormatada: {
        get() {
          // Extraimos o valor do back
          const match = this.impressao.registro.hora_ocorrido.match(/\d{2}:\d{2}/)
          return match ? match[0] : ''
        },
        set(value) {
          // Atualiza com o sufixo horas 
          this.impressao.registro.hora_ocorrido = value ? `${value} horas` : ''
        },
      }
    },
    watch: {
      data () {
        this.init()
        this.changeImpressao()
      },
      propAverbacoes () {
        this.init()
        this.changeImpressao()
      }
    },
    async mounted () {
      if (Object.values(this.data).length > 0 && this.cartorioObj) {
        await this.init()
      }
    },
    methods: {
      getHtml (campo) {
        const html = document.querySelector('#nascimento_pessoa_' + campo).innerHTML

        if (campo == 'averbacoes') {
          this.impressao.averbacoes = html
          this.impressao.averbacao_certidao = html
        } else {
          this.impressao.pessoa[campo] = html
        }

        this.changeImpressao()
      },
      async init () {
        this.impressao = {}

        this.geral()
        this.cartorio()

        /* tratando objeto de pessoa para impressao */
        const pessoa = this.pessoa()
        pessoa.genitores()
        pessoa.gemeos()

        /* tratando objeto de registro para impressao */
        const registro = this.registro()
        registro.outros()
        this.averbacoes()

        this.changeImpressao()

        this.localOcorrencia()

        this.formatDefaultItens()
      },
      geral () {
        let impressao = {}
        const data = this.data

        impressao = {
          averbacoes: null,
          dnv: data.numero_declaracao_nascido_vivo,
          dados: {}
        }

        Object.assign(this.impressao, impressao)
      },
      averbacoes () {
        let averbacoes = ''
        this.impressao.averbacoes = ''
        this.impressao.averbacao_certidao = ''
        this.impressao.averbacao_livro = ''
        this.impressao.averbacao_transporte = ''

        if (this.propAverbacoes && this.propAverbacoes.length > 0) {
          if (!!averbacoes) averbacoes += '<br>'
          try {
            this.propAverbacoes.forEach((averbacao, i) => {
              const line = averbacao.texto_averbacao

              averbacoes += i === 0 ? line : '<br>' + line

              if (averbacao.averb_acrescida_certidao) this.impressao.averbacao_certidao += line + '<br>'
              if (averbacao.averb_impressa_livro) this.impressao.averbacao_livro +=  line + '<br>'
              if (averbacao.averb_impressa_transporte) this.impressao.averbacao_transporte += line + '<br>'

            })
          } catch (e) {
            console.error(e)
          }
        }

        // Caso exista informações complementares também exibimos na impressão
        if (!!this.data.registro && !!this.data.registro.complemento) {
          this.impressao.averbacao_certidao += this.data.registro.complemento + '<br>'
        }

        //this.impressao.averbacoes = averbacoes || ''
      },
      cartorio () {
        const cartorio = Object.assign({}, this.cartorioObj)

        Object.assign(this.impressao, { cartorio: cartorio })
      },
      pessoa () {
        const impressao = {}
        const pessoa = this.data.registro.pessoa

        impressao.pessoa = {
          nome: pessoa.nome,
          cpf: pessoa.cpf,
          naturalidade: pessoa.naturalidade_declarada ? this.tratarNaturalidade(pessoa.naturalidade_declarada, 'naturalidade') : 'NÃO CONSTA',
          uf: pessoa.naturalidade_declarada ? this.tratarNaturalidade(pessoa.naturalidade_declarada, 'uf') : this.verifyUfNaturalidade(),
          sexo: this.sexos[pessoa.sexo] || 'NÃO CONSTA',
          avos: null,
          gemeos: []
        }

        Object.assign(this.impressao, impressao)

        const genitores = () => {
          const genitoresArr = []

          if (!pessoa.genitores.length) {
            Object.assign(impressao.pessoa, { genitores: [] })
            return
          }

          pessoa.genitores.forEach((genitor) => {
            let { pessoa: { nome, naturalidade_declarada, naturalidade }} = genitor
            const genitorObj = {
              nome: nome,
              municipio: naturalidade_declarada || naturalidade,
              uf: genitor.pessoa.uf,
              avos: avos(genitor)
            }
            genitoresArr.push(genitorObj)
          })

          Object.assign(impressao.pessoa, { genitores: genitoresArr })
        }

        const gemeos = () => {
          const gemeos = pessoa.gemeos
          if (!gemeos.length > 0) return
          this.conditionals.gemeos = true

          let impressao = {
            gemeos: []
          }

          gemeos.map(gemeo => {
            impressao.gemeos.push(gemeo)
          })

          Object.assign(this.impressao.pessoa, impressao)
        }

        const avos = (genitor) => {
          if (genitor.filiacao && genitor.filiacao.length > 0) {
            return genitor.filiacao.map(avo => avo.nome).join('; ')
          } else {
            return `NÃO INFORMADO`
          }
        }

        return { genitores, gemeos, avos }
      },
      registro () {

        const impressao = {}
        const registro = this.data.registro

        //Removendo segundos da hora do ocorrido
        const hora_ocorrido = registro.hora_ocorrido ? registro.hora_ocorrido.split(':') : null
        if (hora_ocorrido) hora_ocorrido.pop()

        impressao.registro = {
          matricula: registro.matricula,
          data_registro: this.datas(registro.data_registro),
          data_ocorrido: this.datas(registro.data_ocorrido),
          hora_ocorrido: hora_ocorrido ? hora_ocorrido.join(':') + ' horas' : 'SEM INFORMAÇÂO',
          local: {
            hospital: {
              nome: 'NÃO CONSTA'
            },
            endereco: {
              cidade: 'NÃO CONSTA',
              uf: ''
            }
          }
        }

        const outros = () => {
          const { registro } = this.data
          let impressao = {
            cartorio_endereco: null
          }

          /* endereco cartorio */
          if (registro.livro.cartorio.endereco) {
            impressao.cartorio_endereco = endereco(registro.livro.cartorio.endereco, 'cidade - uf')
          }

          /* local nascimento */
          const { local } = registro // local de nascimento
          if (local)  this.impressao.registro.local = local   
        }

        Object.assign(this.impressao, impressao)
        return { outros }
      },
      datas (datetime) {
        if (!datetime) {
          return {
            extenso: null,
            data: null,
            dia: null,
            mes: null,
            ano: null
          }
        }

        let data = filterDate(datetime)

        const extenso = () => {
          return DataExtensoHelper.dataExtenso(datetime)
        }

        let diaMesAno = data ? data.split('/') : null

        return {
          extenso: extenso(),
          data: data,
          dia: diaMesAno[0],
          mes: diaMesAno[1],
          ano: diaMesAno[2]
        }
      },

      gemeos () {
        const excluir = (gemeo) => {
          const { pessoa: { gemeos } } = this.impressao
          let index = gemeos.indexOf(gemeo)
          gemeos.splice(index, 1)

          this.changeImpressao()
        }

        const adicionar = () => {      
          let { gemeos: { nome, matricula } } = this.forms
          if (nome && matricula) {
            this.impressao.pessoa.gemeos.push({nome, matricula})
            this.changeImpressao()
          }

        }

        return { adicionar, excluir }
      },

      dataDesconhecida () {
        if (!this.data_desconhecida.status) {
          Object.assign(this.data_desconhecida.bkp, this.impressao.registro.data_ocorrido)
          Object.assign(this.impressao.registro.data_ocorrido, {extenso: 'DATA DESCONHECIDA', dia: null, mes: null, ano: null})
        } else {
          Object.assign(this.impressao.registro.data_ocorrido, this.data_desconhecida.bkp)
        }
      },

      changeImpressao () {
        this.$emit('onChangeImpressao', this.impressao)
      },

      handlecreateGenitor (novoGenitor) {        
        this.impressao.pessoa.genitores.push(novoGenitor)
        this.handleCloseAddGenitor()
      },

      handleOpenUpdadeGenitor (index) {
        const genitor = this.impressao.pessoa.genitores[index]
        this.genitorSelecionado = genitor
        this.indexGenitorSeleciodado = index
        this.showGenitorModal = true
      },

      handleUpdateGenitor (index, genitor) {        
        this.impressao.pessoa.genitores[index] = genitor
        this.handleCloseAddGenitor()
      },

      handleDeleteGenitor (index) {
        this.impressao.pessoa.genitores.splice(index, 1)
        this.handleCloseAddGenitor()
      },

      handleCloseAddGenitor () {
        this.showGenitorModal = false
        this.genitorSelecionado = null
      },

      localOcorrencia () {
        if (!!this.data.registro.local && !!this.data.registro.local.hospital) {
          this.impressao.registro.local_nascimento = this.data.registro.local.hospital.nome
        }
        else if (!!this.data.registro.local && !!this.data.registro.local.endereco) {
          this.impressao.registro.local_nascimento = ''
          
          if (this.data.registro.local.sub_tipo == "domicilio") {
            this.impressao.registro.local_nascimento = 'Domicílio, '
          }

          !!this.data.registro.local.endereco.logradouro ? this.impressao.registro.local_nascimento += this.data.registro.local.endereco.logradouro : ''
          !!this.data.registro.local.endereco.logradouro && !!this.data.registro.local.endereco.numero ? this.impressao.registro.local_nascimento += ', ' : ''
          !!this.data.registro.local.endereco.numero ? this.impressao.registro.local_nascimento += this.data.registro.local.endereco.numero : ''
          !!this.data.registro.local.endereco.logradouro && !!this.data.registro.local.endereco.bairro ? this.impressao.registro.local_nascimento += ' - ' : ''
          !!this.data.registro.local.endereco.bairro ? this.impressao.registro.local_nascimento += this.data.registro.local.endereco.bairro : ''

          // !!this.data.registro.local.endereco.cidade ? this.impressao.registro.local_nascimento += this.data.registro.local.endereco.cidade : ''
          // !!this.data.registro.local.endereco.cidade && !!this.data.registro.local.endereco.uf ? this.impressao.registro.local_nascimento += ' - ' : ''
          // !!this.data.registro.local.endereco.uf ? this.impressao.registro.local_nascimento += this.data.registro.local.endereco.uf : ''
        }
        this.changeImpressao()
      },

      tratarNaturalidade (naturalidade, campo) {
        if (!!naturalidade) {
          const formatoPadrao =  naturalidade.indexOf(" - ") // São Paulo - SP 

          // Caso esteja com a formatação padrão quebramos a string para isolar a UF e o Municipio
          if (formatoPadrao > -1) {
            if (campo == 'uf') { 
              const uf = naturalidade.substring(naturalidade.indexOf("-") + 2)
              return uf

            } else {
              return naturalidade.substring(0, (naturalidade.indexOf("-") - 1))
            }
          } else {
            return naturalidade
          }
        } else {
          return campo == 'uf' ? null : 'SEM INFORMAÇÃO'
        }
      },

      formatDefaultItens () {
        !this.impressao.registro.data_ocorrido.extenso ? this.impressao.registro.data_ocorrido.extenso = 'NÃO CONSTA' : ''
        !this.impressao.registro.data_ocorrido.dia ? this.impressao.registro.data_ocorrido.dia = 'N/C' : ''
        !this.impressao.registro.data_ocorrido.mes ? this.impressao.registro.data_ocorrido.mes = 'N/C' : ''
        !this.impressao.registro.data_ocorrido.ano ? this.impressao.registro.data_ocorrido.ano = 'N/C' : ''
        !this.impressao.registro.hora_ocorrido ? this.impressao.registro.hora_ocorrido = 'N/C' : ''
        !this.impressao.registro.local_nascimento ? this.impressao.registro.local_nascimento = 'NÃO CONSTA' : ''
        !this.impressao.registro.data_registro.extenso ? this.impressao.registro.data_registro.extenso  = 'NÃO CONSTA' : ''
        !this.impressao.averbacao_certidao ? this.impressao.averbacao_certidao  = 'NÃO CONSTA' : ''
      },

      verifyUfNaturalidade () {
        // Caso não tenha o campo naturalidade declarada preenchido buscamos em outras informações 
        // Naturalidade com a mesma UF do local de ocorrencia:

        // Estrutura padrão:
        if (!!this.impressao && !!this.impressao.pessoa) {
          if (this.impressao.pessoa.naturalidade_origem == 'endereco_ocorrencia') {
            return !!this.impressao.registro.local.endereco ? this.impressao.registro.local.endereco.uf : ''
          }
          // Mesma naturalidade da Mãe:
          else if (this.impressao.pessoa.naturalidade_origem == 'endereco_mae') {
            const mae = this.impressao.pessoa.genitores.find(genitor => genitor.pessoa.sexo == 'F')
            return !!mae ? mae.uf : ''
          }
          // Mesma naturalidade do Pai:
          else if (this.impressao.pessoa.naturalidade_origem == 'endereco_pai') {
            const pai = this.impressao.pessoa.genitores.find(genitor => genitor.pessoa.sexo == 'M')
            return !!pai ? pai.uf : ''
          }
          // Em alguns casos de migração CRC pode ter a uf preenchida na pessoa:
          else {
            return !!this.impressao.pessoa.uf ? this.impressao.pessoa.uf : ''
          }
        }

        // Variação de estrurtura (Migração)
        else if (!!this.data.registro && !!this.data.registro.pessoa) {
          if (this.data.registro.pessoa.naturalidade_origem == 'endereco_ocorrencia') {
            return !!this.data.registro.local.endereco ? this.data.registro.local.endereco.uf : ''
          }
          // Mesma naturalidade da Mãe:
          else if (this.data.registro.pessoa.naturalidade_origem == 'endereco_mae') {
            const mae = this.data.registro.pessoa.genitores.find(genitor => genitor.pessoa.sexo == 'F')
            return !!mae ? mae.uf : ''
          }
          // Mesma naturalidade do Pai:
          else if (this.data.registro.pessoa.naturalidade_origem == 'endereco_pai') {
            const pai = this.data.registro.pessoa.genitores.find(genitor => genitor.pessoa.sexo == 'M')
            return !!pai ? pai.uf : ''
          }
          // Em alguns casos de migração CRC pode ter a uf preenchida na pessoa:
          else {
            return !!this.data.registro.pessoa.uf ? this.data.registro.pessoa.uf : ''
          }
        }
      }
      
    }
  }
</script>

<style scoped>
  #formulario input, #formulario textarea {
    text-transform: uppercase;
  }

  .editorHtml {
    min-height: 50px;
    border: 1px solid #CCC;
    padding: 10px;
    border-radius: 3px;
    background-color: #FFFFFF;
  }

  .btn-add-genitor:hover:not(:disabled) > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
